import tooltips from './tooltips'
// 自定义tooltips

const install = (Vue) => {
  Vue.directive('tooltips', tooltips)
};

if (window.Vue) {
  window.tooltips = tooltips;
  Vue.use(install); // eslint-disable-line
}

tooltips.install = install;
export default tooltips



// WEBPACK FOOTER //
// ./src/directive/tooltips/index.js